export default "__VITE_ASSET__XcIoLExu__"